import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { useCallback } from 'react';

export const useLogout = () => {
  const { logout } = useKitbagAuth();

  return useCallback(() => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }, [logout]);
};
